module.exports = __webpack_public_path__ + "static/media/Plane Crash.f6545fda.mp4";